.item {
    background: transparent;
    border: none;
}